module.exports = __webpack_public_path__ + "img/Elecocite_120X35.bc4e8088.png";